'use client'

import { PropsWithChildren, useEffect, useRef } from 'react'

type RenderLoggerProps = PropsWithChildren<{
  label?: string
}>

function RenderLogger({ children, label = 'Chat Embed' }: RenderLoggerProps) {
  const renderCountRef = useRef(0)
  renderCountRef.current += 1

  useEffect(() => {
    const style = 'font-weight: 600;'
    console.warn(`%c💬 [ChatRenderLogger] - #${renderCountRef.current} - ${label} render`, style)
  })

  return children as React.ReactNode
}

export default RenderLogger
